var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestaoCreditos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gestao-creditos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gestao-creditos_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.4,137H56.6c-6.5,0-11.8-5.3-11.8-11.8V45.8c0-6.5,5.3-11.8,11.8-11.8h57.7c6.5,0,11.8,5.3,11.8,11.8 v79.4C126.1,131.7,120.9,137,114.4,137z M56.6,42.1c-2.1,0-3.7,1.7-3.7,3.7v79.4c0,2.1,1.7,3.7,3.7,3.7h57.7 c2.1,0,3.7-1.7,3.7-3.7V45.8c0-2.1-1.7-3.7-3.7-3.7H56.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.6,50.4c1.4,1.4,2.8,2.9,4.3,4.5c1.6-1.7,3-3.2,4.4-4.6c2.1,2.1,3.9,3.9,5.9,5.9c-1.4,1.4-2.9,2.9-4.5,4.4 c1.5,1.5,3,2.9,4.5,4.3c-2,2-3.8,3.9-5.8,5.8c-1.3-1.4-2.8-2.9-4.3-4.5c-1.6,1.6-3.1,3.1-4.4,4.5c-2-2-3.9-3.8-5.8-5.8 c1.4-1.4,2.9-2.8,4.5-4.3c-1.6-1.5-3.1-3-4.6-4.4C91.7,54.2,93.6,52.4,95.6,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.8,60.3c1.8-1.8,3.7-3.7,5.6-5.6c1.4,1.4,2.8,2.8,4.2,4.3c3.2-3.3,6.4-6.4,9.5-9.6c2,2,3.9,3.9,5.7,5.7 c-5,5-10.1,10.1-15.1,15.1C65.4,66.9,62,63.5,58.8,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.6,88.7c-7,0-13.9,0-20.8,0c0-2.6,0-5.3,0-7.9c6.9,0,13.8,0,20.8,0C81.6,83.4,81.6,86,81.6,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.4,88.7c-7,0-13.9,0-20.8,0c0-2.6,0-5.3,0-8c6.9,0,13.9,0,20.8,0C110.4,83.4,110.4,86,110.4,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.8,95.6c6.9,0,13.8,0,20.8,0c0,2.6,0,5.3,0,7.9c-6.9,0-13.8,0-20.8,0C60.8,100.9,60.8,98.3,60.8,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,103.6c0-2.7,0-5.3,0-7.9c4.9,0,9.8,0,14.8,0c0,2.6,0,5.2,0,7.9C99.4,103.6,94.5,103.6,89.5,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.6,110.3c0,2.7,0,5.3,0,7.9c-4.9,0-9.8,0-14.8,0c0-2.6,0-5.2,0-7.9C65.7,110.3,70.6,110.3,75.6,110.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestaoCreditos);
export default __webpack_public_path__ + "static/media/gestao-creditos.09bd5db06ea5168b09485df1facdcb0f.svg";
export { ForwardRef as ReactComponent };